//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DetailAdeInstitucionalniPredpokladPovolenyTypDokumentu.ts						</Name>
//    <Description> Dialog detailu srvvtyp - Povolen� typy pro institucion�ln� p�edpoklad										</Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-25                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvvtyp) GID:(Web.Det.Ts) V1:(ixs_typ,ixs_tip,aktivita,dat_zmena,zmenu_prov) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

    /** inteface - Response slu�eb pro Detail */
    export interface IDetailAdeInstitucionalniPredpokladPovolenyTypDokumentuResponse {
        /** data v�stupu */
        data: Gordic.AdmIsl.Interface.GAdeInstitucionalniPredpokladPovolenyTypDokumentuReadDto,

        result: {
            /** data v�stupu */
            data: Gordic.AdmIsl.Interface.GAdeInstitucionalniPredpokladPovolenyTypDokumentuReadDto,
            /** chyby */
            errors: {
                /** zpr�va chyby */
                message: string
            }[],
            /** typ v�stupu operace */
            kind: Adm.Utils.GOperationResultKind
        }
    }

	//#endregion

	/** Dialog detailu  */
	@gcontent
    export class DetailAdeInstitucionalniPredpokladPovolenyTypDokumentu extends GContentBase<DetailBase> {

		//#region attributes

        private gridRemoteControl: Gordic.Components.GridRC<any>;
        private gridCssClass: string;

            /** PK - ixs_typ */
            private ixs_typ: string | null;
            /** PK - ixs_tip */
            private ixs_tip: string | null;
        
        /** data detailu */
        private data: Gordic.AdmIsl.Interface.GAdeInstitucionalniPredpokladPovolenyTypDokumentuReadDto;
		/** p��znak p��m�ho p��stupu na detail */
		private detailCommand: boolean
		/** Tab pro xxxx */
		//private strediskaTab: GStrediskaTab;

		//#endregion

		//#endregion


        /** onContentReady */
        public onContentReady() {
            this.init();
        }
		//#region ready & init

        public closing() {
            return DetailBase.CloseAction(this);
        }

        /** refreshDetail content */
        private refreshDetail(): void {
			this.load();
		}

        /** Na�ten� dat ze serveru na n�sledn� nastaven� na detail okn� */
        private loadData() {
            this.editMode = false;      // na��t�n� jde v�dy do ReadOnly m�du
            var fragments: string[] = [Utils.GAdmIslConst.detail];
            if (this.newRecord)
                fragments.push(Utils.GAdmIslConst.defaultValuesForNewRecord);
            var readResult: any = this.isl.AdeInstitucionalniPredpokladPovolenyTypDokumentu.read({
                data: { ixs_typ: this.ixs_typ, ixs_tip: this.ixs_tip },
                fragments: fragments
            } ).get();
            // SUCCESS
            readResult.done((output: IDetailAdeInstitucionalniPredpokladPovolenyTypDokumentuResponse) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.data = output.data;
                    this.sxsDetail = this.data.ixs_typ + "#" + this.data.ixs_tip + "#";
                    // p�evzet� dat do PK
                    this.ixs_typ = this.data.ixs_typ || null;
                    this.ixs_tip = this.data.ixs_tip || null;
                    this.MetaData = this.data.MetaData || null;
                    this.Permissions = this.data.Permissions || null;
                    this.CreateStatusBar(this.data, this.newRecord);
                    this.createForm();
                    this.element.findFields().gfield("model", "apply", this.data);
                    if (this.newRecord) 
                        this.SetEditMode(true);       // p�i NEW je okno ihned p�epnuto do edit re�imu - mus� b�t p�ed setMenuButtons()
                    this.SetMenuButtons(this.editMode);
                    this.createSidebar();
                } else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowErrorNot({ text: error.message, title: "jres:33000151" });
                    }
                }
            });
            // ERROR
            readResult.fail((err) => {
                console.error("Chyba na�ten�! " + err);
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.ShowErrorNot({ text: "jres:32131045!", title: "jres:33000151" })
            });   
        } // loadData

        private updateGrid( dto: Gordic.AdmIsl.Interface.GAdeInstitucionalniPredpokladPovolenyTypDokumentuReadDto ): any {
            return this.isl.AdeInstitucionalniPredpokladPovolenyTypDokumentu.list({
              filters: { ixs_typ: dto.ixs_typ, ixs_tip: dto.ixs_tip },
            }).getView()
        }

		//#endregion

        /** Ulo�en� dat formul��e do datab�ze */
        private saveData(nova_data: Gordic.AdmIsl.Interface.GAdeInstitucionalniPredpokladPovolenyTypDokumentuSaveDto): void {
            nova_data.NewRecord = this.newRecord;
            var upsertResult: any = this.isl.AdeInstitucionalniPredpokladPovolenyTypDokumentu.upsert({ data: nova_data }).get();
            upsertResult.done((output: IDetailAdeInstitucionalniPredpokladPovolenyTypDokumentuResponse) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderSrvvtyp");
                    this.refreshGrid(output.data, this.newRecord);
                    this.newRecord = false;
                    this.data = output.data; // prevezmu nova data vznikla ulozenim
                    this.sxsDetail = this.data.ixs_typ + "#" + this.data.ixs_tip + "#";
                    this.ixs_typ = this.data.ixs_typ || null;
                    this.ixs_tip = this.data.ixs_tip || null;
                    this.MetaData = this.data.MetaData || null;
                    this.Permissions = this.data.Permissions || null;
                    this.CreateStatusBar(this.data, this.newRecord);
                    this.createForm();                // znovu vytvo��m� cel� form 
                    this.element.findFields().gfield("model", "apply", this.data);  // nasetov�n�� nov�ch dat do detailu
                    this.SetEditMode(false);
                    this.SetMenuButtons(false);
                    this.ShowSucessNot({ title: "jres:33000151", text: "jres:29807955" })
                    this.createSidebar();
                }
                else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowErrorNot({ title: "jres:33000151", text: error.message })     // flash ne�sp�n�ho ulo�en�
                    }
                }

            });

            upsertResult.fail((err) => {
                console.error("Chyba ulo�en�! ");    
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.ShowErrorNot({ text: "jres:32000125!", title: "jres:33000151", exception: err.responseJSON.exception })
            });            
        }

        private refreshGrid(output: Gordic.AdmIsl.Interface.GAdeInstitucionalniPredpokladPovolenyTypDokumentuReadDto, newRecord: boolean) {
            var gridElement = this.gridRemoteControl as any;
            var grid = gridElement.gridInstance.element;
            if (grid.length != 0) {
                this.updateGrid(output).done((d: Gordic.Data.View) => {
                   var data = d.getDataRows(true, "data")[0];
                   var view: Gordic.Data.View = grid.ggrid("getView");
                   if (this.newRecord == true)
                      view.updateData(data, "add");
                   else
                      view.updateData(data, "update");
                   grid.ggrid("setData", view);
               });
            }
        }

		/** init content */
		private init() {
			DetailBase.DetailBaseInit(this);
			this.formElement = null;
			// lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				var GinListControlsObject = (Gin.DetailBuilderComponents as any).GinListControls.create(this);
				this.actions.addRange(GinListControlsObject.actions);
				this.createStatusBar(GinListControlsObject.statusBar);
				$.extend(this, GinListControlsObject.contentExtensions);
			}
			this.setTitle();
			this.createMenuBar();
			this.loadData();            // to soucasne vytvori form podle nactenych dat; 
            // lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				// vytvo�it �ipky na proch�zen� detailu
                (this as any).listControls_setup({
                    //gridRemoteControl: this.gridRemoteControl,
					//funkce, kter� ��dek z gridu p�etransformuje v dto pro zavol�n� this.load(dto); M��e vracet promise.
					rowToDto: function (gridState) {
						return {
                            ixs_typ: gridState.currentRow.data.ixs_typ,
                            ixs_tip: gridState.currentRow.data.ixs_tip,
						};
					},
					//template pro tooltip na �ipce n�sleduj�c�
                    nextItemTemplate: "jres:33000155",
					//template pro tooltip na �ipce p�edchoz�
                    prevItemTemplate: "jres:33000156"
				});
				(this as any).listControls_updateCaptions();
            }
		}

		/** vytvo�it statusbar */
		private createStatusBar(GinListControlsObject?: any) {
			const bar: MenuParams[] = [];
			if (GinListControlsObject !== undefined) {
				bar.push.apply(bar, GinListControlsObject);
			}
			this.statusBar(bar);
		}

		//#endregion
       
		//#region title

		/** nastavit titulek dialogu */
		private setTitle() {
            var title = "";
            if (this.newRecord === false) 
                title = "jres:32131033"  	//RC 32131033 : Detail
            else 
                title = "jres:32000121" //RC 32000121 : Nov� z�znam
            this.title = title;
		}


		//#endregion

		//#region form

		/** vytvo�it formul�� a na�ten� dat ze serveru */
        private createForm() {
            var nemenne = "jres:32131150"; //RC 32131150 : Nem�nn�
            this.MakeForm("FormAdeInstitucionalniPredpokladPovolenyTypDokumentuService");
            this.MakeSection("jres:33000151"); //RC 33000151 : Povolen� typ dokumentu pro institucion�ln� p�edpoklad
            this.MakeSelectField("ixs_tip", Gordic.Prefabs.Select.admSrvstip(), { model: "model.ixs_tip=value.ixs_tip" });
            this.MakeSelectField("ixs_typ", Gordic.Prefabs.Select.sslstyp(), { model: "model.ixs_typ=value.ixs_typ" });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            if (this.newRecord == false)
                this.MakeSection("jres:33000087") //RC 33000087 : Auditn� z�znamy
            this.MakeField("dat_zmena"); 
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
            this.FinishMakeForm();
		}

		//#endregion

		//#region menubar

		private nextAndPreviousAction(next: boolean) {
		    var obj: any;
		    if (next == true)
		        obj = this.gridRemoteControl.current().nextRow.data;
		    else
		        obj = this.gridRemoteControl.current().prevRow.data;
		    this.gridRemoteControl.move(next);
		    var gridElement = this.gridRemoteControl as any;
		    Dialogs.DetailAdeInstitucionalniPredpokladPovolenyTypDokumentuDlg($.content(gridElement.gridInstance.element), { ixs_typ: obj.ixs_typ, ixs_tip: obj.ixs_tip, grid:gridElement.gridInstance.element, newRecord: false })
		this.close();
		}

		/** vytvo�it menubar */
		private createMenuBar() {
			this.actions.addRange({ 
			actNext: {
			        caption: "jres:33000001",  //RC 33000001 : Dal���
			        captionVisible: "never",
			        icon: "gi-arrow-down",
			        run: (ev, ctx) => {
			            this.nextAndPreviousAction(true);
			        }
			    },
			    actPrevious: {
			        caption: "jres:33000002", //RC 33000002 : P�edchoz�
			        captionVisible: "never",
			        icon: "gi-arrow-down gi-rot180",
			        run: (ev, ctx) => {
			            this.nextAndPreviousAction(false);
			        }
			    },
              actSaveRecord: {
                    visible: this.newRecord,
                    icon: "gi-save",
                    caption: "jres:32131041",			//RC 32131041 : Ulo�it
                    run: () => {
                        var nova_data: Gordic.AdmIsl.Interface.GAdeInstitucionalniPredpokladPovolenyTypDokumentuSaveDto = {};       // vytvo��m pr�zdn� objekt spr�vn�ho typu
                        var form = this.findForms("FormAdeInstitucionalniPredpokladPovolenyTypDokumentuService");
                        if (form.gform("isValid")) {
                            this.findFields().gfield("model", "collect", nova_data);    // na�tu do n�j data z formul��e
                            this.saveData(nova_data);                                   // pokus�m se ulo�it data do DB
                        }
                    }
                },
                actEditRecord: {
                        visible: true,
                        icon: "gi-pencil",
                        caption: "jres:32000120",			//RC 32000120 : Editace
                        run: () => {
                            this.SetEditMode(true);
                            this.SetMenuButtons(true);
                        }
                },
                actCancelSaveRecord: {
                        visible: false,
                        icon: "gi-window-close",
                        caption: "jres:32000122",			//RC 32000122 : Ukon�it editaci
                        run: () => {
                            this.refreshDetail();           // ob�erstv�m p�vodn� data z datab�ze
                            this.SetEditMode(false);
                            this.SetMenuButtons(false);
                        }
                },
                actRefresh: {
                        icon: "gi-refresh",
                        caption: "jres:32131040",			//RC 32131040 : Ob�erstven�
                        run: () => {
                        this.refreshDetail();
                        }
                },
                actZavrit: {
                    icon: "gi-window-close",
                    caption: "jres:32131042",				//RC 32131042 : Zav��t
                    run: () => {
                        this.closing().done(() => { this.close() });
                    }
                }
			});

			this.menuBar([
			    { action: this.actions.actSaveRecord, favorite: true },
			    { action: this.actions.actEditRecord, favorite: true },
			    { action: this.actions.actCancelSaveRecord, favorite: true, visible: !this.newRecord },
			    { action: this.actions.actRefresh, favorite: true, visible: !this.editMode },
			    { action: this.actions.actPrevious, favorite: true, align: "opposite", visible: !this.newRecord },
			    { action: this.actions.actNext, favorite: true, align: "opposite", visible: !this.newRecord },
			])
			this.actions.actPrevious?.enabled(this.gridRemoteControl.current()?.prevRow != null);
            this.actions.actNext?.enabled(this.gridRemoteControl.current()?.nextRow != null);
            this.commandBar(this.actions.createBar(["actZavrit*"]));
        }
		//#endregion

		//#region statusbar

		//#endregion

		//#region sidebar

		/** vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {
			this.panelId = "panelNahled";
			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
                leaf: "jres:32131038",								//RC 32131038 : N�hled
                icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel(ITypePanel.Neurceno, $(ev.target))
				},
			} as GSideBarPanelOptions;
			return panel;
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/** vytvo�it sidebar */
		private createSidebar() {
			this.removeSidebar();
			var myPanels: GSideBarBarOptions[] = [];
			var auditPristupu = new Gordic.Adm.WebControls.AdmAuditPristupu();
			var panelAudit = auditPristupu.create( this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			myPanels.push(panelAudit);

			//var extIdentifikace = new Gordic.Adm.WebControls.AdmExtIdentifikace();
			//var panelExtIdentifikace = extIdentifikace.create( this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			//myPanels.push(panelExtIdentifikace);

			//var poznamky = new Gordic.Adm.WebControls.AdmPoznamky();
			//var panelPoznamky = poznamky.create(this,  this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			//myPanels.push(panelPoznamky);

			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: myPanels
				}
			});
		}

		/** ob�erstven� panelu v sidebaru */
		private refreshPanel(type: ITypePanel, elementPanel?: JQuery<HTMLElement>): void {
			var panel: JQuery<HTMLElement> | undefined;
			if (this.sidebar !== undefined) 
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			
			else 
				panel = elementPanel;
            if (panel !== undefined) {
                if (this.panelElement !== undefined) 
                    this.panelElement.remove();
                this.panelElement = $("<div>").appendTo(panel);

                //if (type === ITypePanel.HistorieSpusteni) {
                //	GridUtils.setPanelGrid("jres:32000055", this.row_historie_spusteni, this.gridFormatHistorieSpusteni, this.panelElement);
                //}
                //else {
                this.setPreviewEmpty();
                //}


            }
		}
        /** vytov�en� pr�zdn�ho sidebar panelu s n�hledek */
		private setPreviewEmpty(): void {
			var p7s_element = $("<div'>").addClass("Adm-p7s-class");
			p7s_element.appendTo(this.panelElement);
			p7s_element.text("jres:32131043"); //RC 32131043 : N�hled nen� k dispozici.
		}

		//#endregion


	}
}
